import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpClient } from '@angular/common/http';
import * as fromBulkAcceptanceAction from '../action/bulk-acceptance.action';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { AppToastrService } from '@app/@core/services/toastr/app-toastr.service';
import { OrdersService } from '@app/orders/services/orders.service';
import { IBulkAcceptanceResponse, IBulkAcceptanceData } from '@app/@shared/Models/bulk-acceptance.model';
import { IError } from '../state/app.state';

@Injectable()
export class BulkAcceptanceEffect {
    constructor(private http: HttpClient, private action$: Actions, private appToastrService: AppToastrService, private ordersService: OrdersService) { }
    GetOrderItemList$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(fromBulkAcceptanceAction.BeginBulkAcceptance),
            mergeMap(action =>
                this.ordersService.bulkAcceptOrder(action.requestBody).pipe(
                    map((response: IBulkAcceptanceResponse) => {
                        if (response) {
                            let listItems: IBulkAcceptanceData = response.data;
                            return fromBulkAcceptanceAction.GetBulkAcceptanceSuccess({ payload: listItems });
                        }
                    }),
                    catchError((error) => {
                        let mappedData: IError = { statusCode: error.status, errorMessage: error.message }
                        return of(fromBulkAcceptanceAction.GetBulkAcceptanceError({ payload: mappedData }));
                    })
                )
            )
        )
    )
}